export const ADD_RECURRING_PAYMENT = "RECURRING_PAYMENT";
export const ADD_RECURRING_PAYMENT_SUCCESS = "ADD_RECURRING_PAYMENT_SUCCESS";
export const ADD_RECURRING_PAYMENT_FAILURE = "ADD_RECURRING_PAYMENT_FAILURE";
export const ADD_RECURRING_PAYMENT_RESET = "ADD_RECURRING_PAYMENT_RESET";

export const UPDATE_RECURRING_PAYMENT = "UPDATE_RECURRING_PAYMENT";
export const UPDATE_RECURRING_PAYMENT_SUCCESS = "UPDATE_RECURRING_PAYMENT_SUCCESS";
export const UPDATE_RECURRING_PAYMENT_FAILURE = "UPDATE_RECURRING_PAYMENT_FAILURE";
export const UPDATE_RECURRING_PAYMENT_RESET = "UPDATE_RECURRING_PAYMENT_RESET";
